module.exports = __webpack_public_path__ + "media/src/images/mails/certify_your_learning-495b9469e455d462237e372840a86360.jpg";